module.exports = __webpack_public_path__ + "img/5.319d70cf.png";